import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Loader from 'halogen/PulseLoader';
import '../../styles/core.scss';
import css from './index.scss';

/**
 * Badge Component.
 *
 * @version 1.0.0
 * @author Team Voyager
 */
const Badge = ({ title = '', content = null, badgeStyle = '', showLoader = false }) => {
    const titleElement = title === ''
        ? <div />
        : <div className={css.title}>{title}</div>;

    const badgeElement = content === null && showLoader
        ? <div className={badgeStyle}><Loader margin="2px" size="6px" /></div>
        : <div className={badgeStyle}>{content}</div>;

    return (
        <div className={css.badgeComponent}>
            {titleElement}
            {badgeElement}
        </div>
    );
};

Badge.propTypes = {
    /**
     * Title of the badge
     */
    title: PropTypes.string,
    /**
     * Content to appear on the badge
     */
    content: PropTypes.string,
    /**
     * CSS style of the badge
     */
    badgeStyle: PropTypes.string,
    /**
     * Loader and hide loader
     */
    showLoader: PropTypes.bool
};

export default styleable(css)(Badge);



// WEBPACK FOOTER //
// ./app/components/badge/index.js